import ServiceImg from "../svg/surveyservice.svg"
const Service = () => {
    return (
   
  <img src={ServiceImg} />


    )
  }
  export default Service;